import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Row, Col, Tab, Nav } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import Select from "react-select";
import Drawer from '@mui/material/Drawer';
import DatePicker, { DateObject } from "react-multi-date-picker";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from './../../../modal/Accounts_Management/Daily_Accounts/Add';
import Edit from './../../../modal/Accounts_Management/Daily_Accounts/Edit';

import AddVendor from './../../../modal/Accounts_Management/Daily_Accounts/VendorPayment';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import axios from 'axios';
import moment from 'moment';


const DailyAccounts = () => {
    const tableRef = useRef(null);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [daily_acc, setdailyaccounts] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total, setTotal] = useState(0);

    const [total_credit, setTotalCredit] = useState(0);
    const [total_debit, setTotalDebit] = useState(0);
    const [today_credit, setTodayCredit] = useState(0);
    const [today_debit, setTodayDebit] = useState(0);
    const [yesterday_credit, setYesterdayCredit] = useState(0);
    const [yesterday_debit, setYesterdayDebit] = useState(0);
    const [upcoming_credit, setUpcomingCredit] = useState(0);
    const [upcoming_debit, setUpcomingDebit] = useState(0);

    const [value_filter, setvaluefilter] = useState('');


    const fetchData = (filter = {}) => {
        const params = {
                ...filter,      // spread existing filter key-values
                page,           // add page number
                per_page: perPage, // add per_page
                search: searchTerm  // add search string
        };
        axios.get(`${baseURL}/manage-daily-accounts`, { params: params })
            .then(response => {
                const daily_accounts = response.data.data;
                const last_page = response.data.last_page;
                const total_rec = response.data.total;
                const credit = response.data.credit;
                const debit = response.data.debit;

                // console.log("daily_acc length---------->",daily_acc.length);
                // Show Daily Accounts immediately
                setdailyaccounts(daily_accounts);
                setTotalPages(last_page);
                setTotal(total_rec);
                setHasFetched(true);

                // ---------------------- mini dashboard ----------------
                setTotalCredit(credit);
                setTotalDebit(debit);
                setTodayCredit(response.data.todayCredit);
                setTodayDebit(response.data.todayDebit);
                setYesterdayCredit(response.data.yesterdayCredit);
                setYesterdayDebit(response.data.yesterdayDebit);
                setUpcomingCredit(response.data.upcoming_credit);
                setUpcomingDebit(response.data.upcoming_debit);
            })                  
            .catch(error => {
                console.log('Error fetching Daily Accounts!', error);
                setHasFetched(true);
            });

            // axios.get(`${baseURL}/manage-daily-accounts/get-accounts-vendor`, { params: params })
            // .then(response => {
            //     const accounts_vendor = response.data.data;
            //     console.log('accounts_vendor--------->',accounts_vendor);
            //     setAccountsVendor(accounts_vendor);
            //     setHasFetched(true);
            // })
            // .catch(error => {
            //     console.log('Error fetching Daily Accounts!', error);
            //     setHasFetched(true);
            // });
    };

    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };
    
    const onClose = () => {
        setFilterOpen(false);
    };
    const [selectedItem, setSelectedItem] = useState(null);
    const handleModalToggle_Edit = (data) => {
        axios.get(`${baseURL}/manage-daily-accounts/edit/${data.sno}`)
            .then(response => {
                setSelectedItem(response.data.data); // send full item details to modal
                setModalType("Edit");
                setOpen(true);
            })
            .catch(error => {
                console.log("Failed to fetch package for edit:", error);
            });
    };
    
    const [ledger_account_name, setLedgerAccountName] = useState(null);

    
    const handleGoClick = () => {
            const filter = {
                ledger_id: ledger_id || '',
                sub_ledger_id: sub_ledger_id || '',
                ledger_account_name: ledger_account_name || '',
                date_filter: date_fil_selt_value || '',
                filter: value_filter || '',
            };
            if (date_fil_selt_value === 'custom') {
                filter.start_date = custom_stdt_fil_value || '';
                filter.end_date = custom_eddt_fil_value || '';
            }
            setHasFetched(false);
            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }        
            fetchData(filter);
            onClose();
    };

    useEffect(() => {
        // fetchData();
        handleGoClick();
    }, [value_filter]);


    // pagination
    useEffect(() => {
        if (hasFetched && daily_acc.length === 0) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        pageLength: 10,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());


    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const [ledger_id, setSelectedLedgerOption] = useState(null);
    const [ledgerOptions, setLedgerOptions] = useState([]);
    useEffect(() => {
        const fetchledger = async () => {
            try {
                const response = await axios.get(`${baseURL}/manage-daily-accounts/get-ledger`);
                const ledger = response.data.data.map(ledgers => ({
                        label: ledgers.ledger_name,
                        value: ledgers.sno
                }));
                setLedgerOptions(ledger);
            } catch (error) {
                console.error("Failed to fetch ledger:", error);
            }
        };
        fetchledger();
    }, [baseURL]);


    const [sub_ledger_id, setSelectedSubLedgerOption] = useState(null);
    const [subledgerOptions, setSubledgerOptions] = useState([]);
    useEffect(() => {
        if (ledger_id) {
        const fetchsubledger = async () => {
                            try {
                                const response = await axios.get(`${baseURL}/manage-daily-accounts/get-sub-ledger/${ledger_id}`);
                                const sub_ledger = response.data.data.map(ledgers => ({
                                        label: ledgers.subledger_name,
                                        value: ledgers.sno
                                }));
                                    setSubledgerOptions(sub_ledger);
                            } catch (error) {
                                console.error("Failed to fetch ledger:", error);
                            }
                        };
                        fetchsubledger();
        }
    }, [ledger_id]);
    console.disableYellowBox = true;

    // soft refresh
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

        
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Daily Accounts</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Account Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 mb-2'>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                        <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                        <span className=''>Filter</span>
                    </Link>
                    <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={handleModalToggle}>
                        <span className='me-2'><i class="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Daily Accounts</span>
                    </Link>
                    {open && modalType === "Add" && (
                        <Add show={open} onClose={() => setOpen(false)} refresh={softRefresh} />
                    )}
                    {open && modalType === "Edit" && (
                        <Edit show={open} onClose={() => setOpen(false)} />
                    )}
                    {open && modalType === "AddVendor" && (
                        <AddVendor show={open} onClose={() => setOpen(false)} />
                    )}
                </div>
            </div>
            <Col xl={12} className='mb-3'>
                <Row>
                    <Col xl={12}>

                        <div className="row mb-3">
                            <div className="d-flex align-items-end justify-content-end">
                                <div className="me-2" onClick={() => setvaluefilter('today_credit')}>
                                    <div className=" rounded px-3 py-1 " style={{ backgroundColor: "#fff6f4ff", border: "1px solid #F02300",}}>
                                    <label className="text-black fs-6">
                                        Today Credit
                                    </label>
                                    <div className="d-block text-center">
                                        
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{today_credit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('today_debit')}>
                                    <div
                                    className=" rounded px-3 py-1 "
                                    style={{
                                        backgroundColor: "#fff6f4ff",
                                        border: "1px solid #F02300",
                                    }}
                                    >
                                    <label className="text-black fs-6">
                                        Today Debit
                                    </label>
                                    <div className="d-block text-center">
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{today_debit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('yesterday_credit')}>
                                    <div className="border rounded px-3 py-1 border-warning bg-warning-light ">
                                    <label className="text-black fs-6">
                                        Yesterday Credit
                                    </label>
                                    <div className="d-block text-center">
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{yesterday_credit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('yesterday_debit')}>
                                    <div className="border rounded px-3 py-1 border-warning bg-warning-light ">
                                        <label className="text-black fs-6">
                                            Yesterday Debit
                                        </label>
                                        <div className="d-block text-center">
                                            <label className="text-danger fs-3 m-0 fw-bold">
                                            <span>
                                                <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                            </span>
                                            <span>{yesterday_debit}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('')}>
                                    <div className="border rounded px-3 py-1 border-info bg-info-light ">
                                    <label className="text-black fs-6">
                                        Upcoming Credit
                                    </label>
                                    <div className="d-block text-center">
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{upcoming_credit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('')}>
                                    <div className="border rounded px-3 py-1 border-info bg-info-light ">
                                        <label className="text-black fs-6">
                                            Upcoming Debit
                                        </label>
                                        <div className="d-block text-center">
                                            <label className="text-danger fs-3 m-0 fw-bold">
                                            <span>
                                                <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                            </span>
                                            <span>{upcoming_debit}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('total_credit')}>
                                    <div className="border rounded px-3 py-1 border-success bg-success-light">
                                    <label className="text-black fs-6">
                                        Total Credit
                                    </label>
                                    <div className="d-block text-center">
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{total_credit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="me-2" onClick={() => setvaluefilter('total_debit')}>
                                    <div className="border rounded px-3 py-1 border-danger bg-danger-light ">
                                    <label className="text-black fs-6">
                                        Total Debit
                                    </label>
                                    <div className="d-block text-center">
                                        <label className="text-danger fs-3 m-0 fw-bold">
                                        <span>
                                            <i class="fa-solid fa-indian-rupee-sign me-1"></i>
                                        </span>
                                        <span>{total_debit}</span>
                                        </label>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='row mb-3'>
                            <div className='d-flex align-items-end justify-content-end'>
                                <div className='me-2'>
                                    <div className='border rounded px-3 py-1 border-success bg-success-light'>
                                        <label className='text-black fs-6'>Total Credit</label>
                                        <div className='d-block text-center'>
                                            <label className="text-danger fs-3 m-0 fw-bold">
                                                <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                <span>{credit}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='me-2'>
                                    <div className='border rounded px-3 py-1 border-danger bg-danger-light '>
                                        <label className='text-black fs-6'>Total Debit</label>
                                        <div className='d-block text-center'>
                                            <label className="text-danger fs-3 m-0 fw-bold">
                                                <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                <span>{debit}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="table-container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                {/* Left: Show entries dropdown */}
                                <div>
                                    <label className="me-2">Show</label>
                                    <select
                                        className="form-select d-inline w-auto"
                                        style={{  fontSize: '0.85rem', height: '30px' }}
                                        value={perPage}
                                        onChange={(e) => {
                                            setPerPage(Number(e.target.value));
                                            setPage(1); // Reset to first page
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>

                                {/* Right: Search input */}
                                <div>
                                    <input
                                        type="text"
                                        style={{  fontSize: '0.85rem', height: '40px' }}
                                        placeholder="Search..."
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setPage(1); // Reset page on new search
                                        }}
                                    />
                                </div>
                            </div>
                            <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}>
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-100px'>Date</th>
                                        <th className='min-w-100px'>Ledger / Sub Ledger</th>
                                        <th className='min-w-100px'>Ledger Account</th>
                                        <th className='min-w-50px text-center'>Credit</th>
                                        <th className='min-w-50px text-center'>Debit</th>
                                        <th className='min-w-100px text-end'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {daily_acc.length === 0 && hasFetched ? (
                                        <tr>
                                            <td colSpan="7" className="text-center text-muted py-2">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {daily_acc.map((data) => (
                                                <tr>
                                                    <td>
                                                        <label className='text-black font-w400 fs-7'>{moment(data.account_date).format('DD-MMM-YYYY')}</label>
                                                    </td>
                                                    <td>
                                                        <label className="text-black font-w400 fs-7">{data.ledger_name}</label>
                                                        <div className='d-block'>
                                                            <label className="text-gray-800  font-w600 fs-8">{data.subledger_name}</label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <label className='text-black font-w400 fs-7'>{data.ledger_account_name}</label>
                                                        <div className="d-block">
                                                            <span className="badge badge-success text-white  font-w600 fs-8">
                                                                {data.ordered_id}
                                                                </span>
                                                        </div>
                                                    </td>
                                                    <td align='right'>
                                                        <label className="text-danger fs-6 m-0 font-w500">
                                                            <label className="text-danger fs-6 m-0 font-w500">
                                                                {data.is_credit === 1 ? (<span><i class="fa-solid fa-indian-rupee-sign me-1"></i>{data.amount}</span>) : ('-')}
                                                            </label>
                                                        
                                                        </label>
                                                    </td>
                                                    <td align='right'>
                                                        <label className="text-danger fs-6 m-0 font-w500">
                                                            <label className="text-danger fs-6 m-0 font-w500">
                            {data.is_credit === 0 ? (<span><i class="fa-solid fa-indian-rupee-sign me-1"></i>{data.amount}</span>) : ('-')}
                        </label>
                                                            {/* <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span>
                                                            <span>5000</span> */}
                                                        </label>
                                                    </td>
                                                    <td class="text-end">
                                                        <span >
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                                <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(data)}>
                                                                    <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                                </Button>
                                                            </OverlayTrigger>
                                                            
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                            {open && modalType === "Edit" && (
                                <Edit
                                    show={open}
                                    onClose={() => setOpen(false)}
                                    DailyAccData={selectedItem} 
                                    refresh={softRefresh}
                                        // Pass the selected item data
                                />
                            )}
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    {daily_acc.length > 0 ? (
                                        <span className="text-muted">
                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + daily_acc.length} of {total} entries
                                        </span>
                                    ):(
                                        <span className="text-muted">
                                            Showing 0 to 0 of 0 entries
                                        </span>
                                    )}
                                </div>

                                {/* Bottom right: Pagination */}
                                <nav>
                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                        </li>
                                        {[...Array(totalPages)].map((_, i) => (
                                        <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                        </li>
                                        ))}
                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                        </div>

                        <Drawer
                            anchor="right"
                            open={filterOpen}
                            onClose={() => setFilterOpen(false)}
                            disableEscapeKeyDown
                            BackdropProps={{
                                onClick: (e) => e.stopPropagation(),
                            }}
                            sx={{
                                width: 400,
                                flexShrink: 0,
                                '& .MuiDrawer-paper': {
                                    width: 400,
                                    boxSizing: 'border-box',
                                },
                                '@media (max-width: 375px)': {
                                    '& .MuiDrawer-paper': {
                                        width: 320,
                                    },
                                },
                                '@media (max-width: 320px)': {
                                    '& .MuiDrawer-paper': {
                                        width: 280,
                                    },
                                },
                            }}
                        >
                            <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                                <h5 className='fs-4' style={{ color: '#ea1d25' }}>Daily Accounts Filter</h5>
                                <div>
                                    <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                                        <span className='fs-2'>×</span>
                                    </Button>
                                </div>
                            </div>
                            <div className='card border-0'>
                                <div className='card-body py-0'>
                                    <div className='row mb-2 py-2'>
                                        <div className="col-lg-12 mb-2">
                                            <label className="text-black font-w500 fs-7">Ledger</label>
                                            <Select
                                                value={ledgerOptions.find(option => option.value === ledger_id) || null}
                                                onChange={(selectedOption) => setSelectedLedgerOption(selectedOption.value)}
                                                options={ledgerOptions}
                                                placeholder="Select Ledger"
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-2">
                                            <label className="text-black font-w500 fs-7">Sub Ledger</label>
                                            <Select
                                    //    defaultValue={subledger_options[0]}
                                            //   onChange={setSelectedOption}
                                                value={subledgerOptions.find(option => option.value === sub_ledger_id) || null}
                                                onChange={(selectedOption) => setSelectedSubLedgerOption(selectedOption.value)}
                                                options={subledgerOptions}
                                                placeholder="Select Sub Ledger"
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-2">
                                            <label className="text-black font-w500 fs-7">Ledger Account</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                placeholder="Ledger Account"
                                                value={ledger_account_name}
                                                
                                                onChange={(e) => {            setLedgerAccountName(e.target.value); }}
                                            />
                                        </div>
                                        <div className="col-lg-12 mb-2">
                                            <label className="text-black font-w500 fs-7">Date</label>
                                            <Select
                                                value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                                onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                                options={date_fil_options}
                                                menuPlacement="top"
                                            />
                                        </div>
                                        {date_fil_selt_value === "all" && <></>}
                                        {date_fil_selt_value === "today" && (
                                            <div className="col-lg-12 mb-2">
                                                <label className="text-black font-w500 fs-7">Today</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        // value={"05/18/2020 02:20:36 PM"}
                                                        value={today_fil_value}
                                                        onChange={setTodayFilValue}
                                                        format="DD-MM-YYYY"
                                                        // format="DD/MM/YYYY hh:mm:ss A"
                                                        readOnly={true}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {date_fil_selt_value === "this_week" && (
                                            <>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                                    <div className='datepicker-wrapper d-flex'>
                                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                        <DatePicker
                                                            value={week_stdt_fil_value}
                                                            onChange={setWeekSTDTFilValue}
                                                            format="DD-MM-YYYY"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">End Date</label>
                                                    <div className='datepicker-wrapper d-flex'>
                                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                        <DatePicker
                                                            value={week_eddt_fil_value}
                                                            onChange={setWeekEDDTFilValue}
                                                            format="DD-MM-YYYY"
                                                            calendarPosition="top-end"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {date_fil_selt_value === "this_month" && (
                                            <div className="col-lg-12 mb-2">
                                                <label className="text-black font-w500 fs-7">This Month</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={month_fil_value}
                                                        onChange={setMonthFilValue}
                                                        format="MMM-YYYY"
                                                        calendarPosition="top"
                                                        mode="single"
                                                        onlyMonthPicker={true}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {date_fil_selt_value === "custom" && (
                                            <>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">Start Date</label>
                                                    <div className='datepicker-wrapper d-flex'>
                                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                        <DatePicker
                                                            value={custom_stdt_fil_value}
                                                            onChange={setCustomSTDTFilValue}
                                                            format="DD-MM-YYYY"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-2">
                                                    <label className="text-black font-w500 fs-7">End Date</label>
                                                    <div className='datepicker-wrapper d-flex'>
                                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                        <DatePicker
                                                            value={custom_eddt_fil_value}
                                                            onChange={setCustomEDDTFilValue}
                                                            format="DD-MM-YYYY"
                                                            calendarPosition="top-end"
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-1">
                                    <Button className="me-2 btn-sm" variant="secondary" onClick={() =>{ setSelectedLedgerOption();
                                    setSelectedSubLedgerOption();
                                    setLedgerAccountName();
                                    setDateFilSeltValue('all');
                                    softRefresh();                            onClose();
                                    setvaluefilter('');
                                    }} >
                                        <span className='font-w400'>Reset</span>
                                    </Button>
                                    <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                                        <span className='font-w400'>Go</span>
                                    </Button>
                                </div>
                            </div>
                        </Drawer>

                    </Col>
                </Row>          
            </Col>

        </>
    )


}

export default DailyAccounts;